import { Box, LinearProgress } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';

const Loading = () => {
    const loading = useSelector((state) => state.imageViewerStore.isLoading);
  return (
    <>
    {loading &&  <Box
        sx={{
          width: "100%",
          height: "0", 
          overflow: "hidden",
        }}
      >
        <LinearProgress sx={{ height: "0.15rem", padding: 0, width:"100%"}} />
      </Box>}
      </>
   
  )
}

export default Loading